export const MARGIN_MOBILE = 16;
export const MARGIN_TABLET = 24;
export const MARGIN_DESKTOP = 32;
export const MARGIN_DESKTOP_LARGE = 48;